import React from 'react';
import { Sparkles } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';
import AnimatedBorderBadge from './AnimatedBorderBadge';

interface FeaturesVideoShowcaseSectionProps {
  headline?: string;
  subheadline?: string;
}

const FeaturesVideoShowcaseSection: React.FC<FeaturesVideoShowcaseSectionProps> = ({
  headline = "Your Story In, Your Revenue Out.",
  subheadline = "Turn any lead into a loyal customer - captured, nurtured, and converted. Automatically."
}) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  const headingColor = isDark ? '#FFFFFF' : '#111111';
  const textColor = isDark ? '#AAAAAA' : '#666666';
  const borderColor = isDark ? '#333333' : '#E0E0E0';

  return (
    <section className="pt-16 pb-16 transition-colors duration-300">
      <div className="max-w-6xl mx-auto px-8 lg:px-8">
        {/* Centered Text Content */}
        <div className="flex flex-col items-center text-center space-y-6 max-w-3xl mx-auto mb-12">
          {/* Badge with animated border */}
          <AnimatedBorderBadge text="Platform" icon={Sparkles} />
          
          <h2 
            className="text-3xl lg:text-4xl font-bold leading-[1.1] tracking-tight transition-colors duration-300"
            style={{ color: headingColor }}
          >
            {headline}
          </h2>

          <p 
            className="text-sm leading-relaxed max-w-lg transition-colors duration-300" 
            style={{ color: textColor }}
          >
            {subheadline}
          </p>
        </div>

        {/* Video - Centered */}
        <div className="max-w-2xl mx-auto">
          <div 
            className="relative rounded-xl overflow-hidden group"
            style={{ 
              border: `1px solid ${borderColor}`,
              boxShadow: isDark 
                ? '0 20px 40px -10px rgba(0, 0, 0, 0.5)' 
                : '0 20px 40px -10px rgba(0, 0, 0, 0.15), 0 10px 20px -5px rgba(0, 0, 0, 0.1)'
            }}
          >
            {/* Mobile video - 9:16 portrait */}
            <video
              autoPlay
              muted
              loop
              playsInline
              controls
              className="md:hidden w-full h-auto"
            >
              <source 
                src="https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/video-content/V24%20Everything%20In%20One%20Place%20Male%20Version%20(1).mp4" 
                type="video/mp4" 
              />
            </video>

            {/* Tablet/Desktop video - landscape */}
            <video
              autoPlay
              muted
              loop
              playsInline
              controls
              className="hidden md:block w-full h-auto"
            >
              <source 
                src="https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/video-content/V24%20Everything%20In%20One%20Place%20Male%20Version%20(1).mp4" 
                type="video/mp4" 
              />
            </video>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesVideoShowcaseSection;
